import { blue, red } from '@material-ui/core/colors';

import { createTheme } from '@material-ui/core/styles';

const fontWeights = {
  light: 300,
  normal: 400,
  semibold: 500,
  bold: 700
};
const colors = {
  offBlack: '#2F2F2F',
  darkGrey: '#707070',
  medGrey: '#D6D6D6',
  lightGrey: '#F2F2F2',
  white: '#fff',
  black: '#0F0F0F',
  yellow: '#F9DC5C',
  gold: '#FFCF31',
  mintGreen: '#6CAE75',
  SSSF_red: '#EF5350',
  navey: '#005776',
  limeGreen: '#C2CD23',
  purple: '#AA8BFF',
  blue: '#009FFA',
  orange: '#ff9933',
  pink: '#ff33cc'
};

// Create a theme instance.
const globalTheme = createTheme({
  spacing: 8,
  breakpoints: {
    values: {
      xs: 500,
      sm: 768,
      md: 960,
      lg: 1280,
      xl: 1620,
      xxl: 2000
    }
  },
  palette: {
    primary: {
      main: '#005776',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#19857b'
    },

    error: {
      main: red.A400,
      light: colors.SSSF_red
    },
    blue: {
      main: blue.A400
    },
    background: {
      default: colors.lightGrey
    },
    white: {
      main: colors.white
    },
    yellow: {
      main: colors.yellow
    },
    black: {
      main: colors.black,
      light: colors.offBlack,
      contrastText: colors.white
    },
    grey: {
      main: colors.medGrey,
      dark: colors.darkGrey
    },
    green: {
      main: colors.limeGreen
    },
    purple: {
      main: colors.purple
    },
    status: {
      notStarted: colors.medGrey,
      notStartedDue: colors.SSSF_red,
      incomplete: colors.gold,
      unverified: colors.purple,
      qa_review: colors.pink,
      flagged: colors.SSSF_red,
      complete: colors.mintGreen,
      verified: colors.blue
    }
  },
  typography: {
    fontFamily: [
      'Roboto Condensed',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(','),
    fontWeightLight: 200,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    h6: {
      fontWeight: fontWeights.bold
    },
    subtitle1: {
      fontSize: '12px',
      color: colors.darkGrey,
      fontWeight: fontWeights.bold
    },
    subtitle2: {
      fontSize: '16px',
      color: colors.black,
      fontWeight: fontWeights.bold
    }
  }
});

const theme = createTheme(
  {
    overrides: {
      MuiTypography: {
        gutterBottom: {
          paddingBottom: globalTheme.spacing(2.5),
          marginBottom: globalTheme.spacing(2.5)
        }
      },
      MuiButton: {
        contained: {
          fontFamily: 'Roboto',
          fontWeight: fontWeights.bold
        },
        containedPrimary: {
          fontFamily: 'Roboto',
          fontWeight: fontWeights.bold,
          color: globalTheme.palette.primary.main,
          '& .MuiButton-label': {
            color: globalTheme.palette.white.main
          }
        }
      },
      MuiCircularProgress: {
        root: {
          display: 'block',
          margin: '0 auto'
        }
      },
      MuiTablePagination: {
        caption: {
          display: 'block!Important'
        }
      },
      MuiAlertTitle: {
        root: {
          paddingBottom: 0,
          marginBottom: globalTheme.spacing(1)
        }
      },
      MuiDropzoneArea: {
        root: {
          backgroundColor: 'transparent',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          padding: globalTheme.spacing(1.25)
        },
        textContainer: {
          display: 'flex',
          flexFlow: 'row-reverse',
          flexWrap: 'wrap',
          alignItems: 'center'
        },
        icon: {
          '& path': {
            fill: colors.darkGrey
          }
        },
        text: {
          fontSize: globalTheme.spacing(2),
          fontWeight: fontWeights.bold
        }
      },
      MuiDropzonePreviewList: {
        root: {
          justifyContent: 'center'
        }
      },
      MuiAlert: {
        standardSuccess: {
          border: 'solid 2px green'
        }
      }
    }
  },
  globalTheme
);

export default theme;
